module.exports = __webpack_public_path__ + "static/media/cart.38dae47f.svg";